import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Resource } from '../../types';

interface ResourceDetailViewProps {
  resource: Resource;
  onBack: () => void;
  onEdit: () => void;
  onVerify: (verified: boolean) => void;
  onStatusChange: (isActive: boolean) => void;
}

const ResourceDetailView: React.FC<ResourceDetailViewProps> = ({
  resource,
  onBack,
  onEdit,
  onVerify,
  onStatusChange
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <button
          onClick={onBack}
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Resources
        </button>
        <h1 className="text-2xl font-bold text-gray-900">{resource.name}</h1>
      </div>
      
      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-600">Resource details view - coming soon</p>
        <div className="mt-4">
          <button
            onClick={onEdit}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Edit Resource
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResourceDetailView;
